import { configConstants } from "../../constants";

export function deleteAmenityReducer(state = {}, action) {
  switch (action.type) {
    case configConstants.DELETE_AMENITY_REQUEST:
      return { loading: true };
    case configConstants.DELETE_AMENITY_SUCCESS:
      return { amenity: action.payload };
    case configConstants.DELETE_AMENITY_FAILURE:
      return { loading: true };
    default:
      return state;
  }
}
